// extracted by mini-css-extract-plugin
export default {"container":"locations_container__DpGsx","loader":"locations_loader__-voI4"};